// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.star_4b0b1dcf {
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  padding-right: 0.334rem;
}
.star_4b0b1dcf:last-child {
  padding-right: 0;
}
.star_readonly_4b0b1dcf {
  cursor: default;
}
.star_size10_4b0b1dcf {
  padding-right: 0.25rem;
}
.star_size18_4b0b1dcf {
  padding-right: 0.5rem;
}
.star_size24_4b0b1dcf {
  padding-right: 0.667rem;
}
.star_size36_4b0b1dcf {
  padding-right: 1rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"star": `star_4b0b1dcf`,
	"star_readonly": `star_readonly_4b0b1dcf`,
	"star_size10": `star_size10_4b0b1dcf`,
	"star_size18": `star_size18_4b0b1dcf`,
	"star_size24": `star_size24_4b0b1dcf`,
	"star_size36": `star_size36_4b0b1dcf`
};
export default ___CSS_LOADER_EXPORT___;
